module.exports = __webpack_public_path__ + "img/ranheim-logo-small.1a691325.png";